/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsForwardLinkRequest
 */
export interface MelcoModelsForwardLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsForwardLinkRequest
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsForwardLinkRequest
     */
    target_url?: string | null;
}

export function MelcoModelsForwardLinkRequestFromJSON(json: any): MelcoModelsForwardLinkRequest {
    return MelcoModelsForwardLinkRequestFromJSONTyped(json, false);
}

export function MelcoModelsForwardLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsForwardLinkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'target_url': !exists(json, 'target_url') ? undefined : json['target_url'],
    };
}

export function MelcoModelsForwardLinkRequestToJSON(value?: MelcoModelsForwardLinkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'target_url': value.target_url,
    };
}


